/* eslint-disable vue/component-definition-name-casing */
import Vue from 'vue';
import GModal from '@/components/global/GModal';
import GRatingInline from '@/components/global/rating-inline/rating-inline';
import GProduct from '@/components/global/product/product';
import GFMP from '@/components/global/GFmp';
import GImageUser from '@/components/global/GImageUser';
import GUserLevel from '@/components/global/GUserLevel';
import LoaderSpin from '@/shared/UIComponents/LoaderSpin';
import GProductSociolla from '@/components/global/product/product-sociolla';
import GTopAds from '@/components/global/ads/top-ads';
import GSideAds from '@/components/global/ads/side-ads';
import GSideSmallerAds from '@/components/global/ads/side-smaller-ads';
import SvgImg from '@/components/global/svg-img';
import ProgressBar from '@/shared/UIComponents/ProgressBar';
import Intersect from 'vue-intersect';

Vue.component('GModal', GModal);
Vue.component('GRatingInline', GRatingInline);
Vue.component('GProduct', GProduct);
Vue.component('GFMP', GFMP);
Vue.component('GImageUser', GImageUser);
Vue.component('GUserLevel', GUserLevel);
Vue.component('GLoaderSpin', LoaderSpin);
Vue.component('GProductSociolla', GProductSociolla);
Vue.component('GTopAds', GTopAds);
Vue.component('GSideAds', GSideAds);
Vue.component('GSideSmallerAds', GSideSmallerAds);
Vue.component('SvgImg', SvgImg);
Vue.component('ProgressBar', ProgressBar);
Vue.component('Intersect', Intersect);
